import React, { FC, useContext } from 'react';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import { ShowProductShowcase } from './components';

export const ProductShowcase: FC = () => {
  const { t } = useContext(LocalizationContext);

  return (
    <>
      <SettingsBlock title={t('setting.shell.showcaseGoods')}>
        <SettingsFrame>
          <ShowProductShowcase />
        </SettingsFrame>
      </SettingsBlock>
    </>
  );
};
